






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PartFooter extends Vue {
  @Prop({ default: 50 }) height!: number;
}
